/**
 * @name applyAttribute
 *
 * @description Adds or removes an attribute from an element
 *
 * @example
 * import { applyAttribute } from '@workbench/core';
 *
 * applyAttribute(document.body, 'disabled', true); // adds attribute [disabled]
 * applyAttribute(document.body, 'disabled', false); // removes attribute [disabled]
 */
export const applyAttribute = (el: HTMLElement, attribute: string, value: boolean): void => {
  if (value) {
    el.setAttribute(attribute, '');
  } else {
    el.removeAttribute(attribute);
  }
};
